// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function $$boolean(row, key) {
  const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(row, key));
  if (value !== undefined) {
    return value;
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_pull_response"
    });
}

function decode_pull(row) {
  return {
    number: Mapre_wire__Json.integer(row, "number"),
    title: Mapre_wire__Json.string(row, "title"),
    url: Mapre_wire__Json.string(row, "url"),
    head: Mapre_wire__Json.string(row, "head_sha"),
    base: Mapre_wire__Json.string(row, "base"),
    state: Mapre_wire__Json.string(row, "state"),
    draft: $$boolean(row, "draft"),
    mergeable: Js__Js_json.decodeBoolean(Mapre_wire__Json.get(row, "mergeable")),
    checks: Mapre_wire__Json.string(row, "mergeable_state")
  };
}

function decode_detail(json) {
  const operation = Mapre_wire__Json.get(json, "merge");
  return {
    pull: decode_pull(Mapre_wire__Json.get(json, "pull")),
    files: Stdlib__List.map((function (row) {
      return {
        path: Mapre_wire__Json.string(row, "filename"),
        patch: Stdlib__Option.value(Js__Js_json.decodeString(Mapre_wire__Json.get(row, "patch")), "Diff not available for this file."),
        additions: Mapre_wire__Json.integer(row, "additions"),
        deletions: Mapre_wire__Json.integer(row, "deletions")
      };
    }), Stdlib__Array.to_list(Mapre_wire__Json.array(json, "files"))),
    truncated: $$boolean(json, "files_truncated"),
    version: Mapre_wire__Json.integer(json, "project_version"),
    can_merge: $$boolean(json, "can_merge"),
    merge_status: Caml_obj.caml_equal(operation, null) ? undefined : Js__Js_json.decodeString(Mapre_wire__Json.get(operation, "status")),
    failure: Caml_obj.caml_equal(operation, null) ? undefined : Js__Js_json.decodeString(Mapre_wire__Json.get(operation, "failure_code"))
  };
}

function initial(request_id) {
  return {
    request_id,
    pulls: /* [] */ 0,
    next_page: undefined,
    detail: undefined,
    loading: true,
    pending: false,
    uncertain: false,
    message: ""
  };
}

function update(t, request_id) {
  if (/* tag */ typeof request_id !== "object" && typeof request_id !== "function") {
    switch (request_id) {
      case /* Loading */ 4 :
        return {
          request_id: t.request_id,
          pulls: t.pulls,
          next_page: t.next_page,
          detail: t.detail,
          loading: true,
          pending: t.pending,
          uncertain: t.uncertain,
          message: ""
        };
      case /* Pending */ 5 :
        return {
          request_id: t.request_id,
          pulls: t.pulls,
          next_page: t.next_page,
          detail: t.detail,
          loading: t.loading,
          pending: true,
          uncertain: false,
          message: ""
        };
      default:
        return t;
    }
  } else {
    switch (request_id.TAG) {
      case /* Reviewing */ 2 :
        return {
          request_id: request_id._0,
          pulls: t.pulls,
          next_page: t.next_page,
          detail: undefined,
          loading: true,
          pending: false,
          uncertain: false,
          message: ""
        };
      case /* Listed */ 3 :
        const pulls = request_id._0;
        return {
          request_id: t.request_id,
          pulls: request_id._2 ? Stdlib.$at(t.pulls, pulls) : pulls,
          next_page: request_id._1,
          detail: t.detail,
          loading: false,
          pending: t.pending,
          uncertain: t.uncertain,
          message: t.message
        };
      case /* Selected */ 4 :
        const detail = request_id._0;
        return {
          request_id: t.request_id,
          pulls: t.pulls,
          next_page: t.next_page,
          detail: detail,
          loading: false,
          pending: false,
          uncertain: Caml_obj.caml_equal(detail.merge_status, "uncertain") || Caml_obj.caml_equal(detail.merge_status, "issuing"),
          message: ""
        };
      case /* Accepted */ 5 :
        const status = request_id._0;
        return {
          request_id: request_id._2,
          pulls: t.pulls,
          next_page: t.next_page,
          detail: t.detail,
          loading: t.loading,
          pending: false,
          uncertain: status === "uncertain" || status === "issuing",
          message: Stdlib__Option.value(request_id._1, "")
        };
      case /* Failed */ 6 :
        return {
          request_id: t.request_id,
          pulls: t.pulls,
          next_page: t.next_page,
          detail: t.detail,
          loading: false,
          pending: false,
          uncertain: t.uncertain || request_id._1,
          message: request_id._0
        };
      default:
        return t;
    }
  }
}

function can_submit(t) {
  if (!t.loading && !t.pending && !t.uncertain) {
    return Stdlib__Option.fold(false, (function (d) {
      return d.can_merge;
    }), t.detail);
  } else {
    return false;
  }
}

function progress(t) {
  const d = t.detail;
  if (d !== undefined && (d.pull.state === "merged" || Caml_obj.caml_equal(d.merge_status, "merged"))) {
    return "Merged PR #" + (String(d.pull.number) + (" into " + d.pull.base));
  }
  if (t.uncertain) {
    return "Merge result unknown. Refresh status before taking another action.";
  } else if (t.pending) {
    return "Merging reviewed commit...";
  } else if (t.loading) {
    return "Loading pull requests...";
  } else if (d !== undefined && Caml_obj.caml_equal(d.merge_status, "failed")) {
    return "Merge blocked: " + Stdlib__Option.value(d.failure, "Refresh PR status before trying again.");
  } else {
    return t.message;
  }
}

export {
  initial,
  update,
  decode_pull,
  decode_detail,
  can_submit,
  progress,
}
/* Mapre_wire__Json Not a pure module */
